import styled from "styled-components";
import React, { Fragment } from "react";

import { TableRow } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import { toLocaleIsoString } from "@utils/time";

import type { FC } from "react";
import type { Statistic } from "@interfaces/stats";

type RowProps = {
  row: Statistic;
};

const Row: FC<RowProps> = ({ row }) => {
  return (
    <Fragment>
      <TableRow hover sx={{ height: "50px" }}>
        <TableCell width={130} align="right">
          <NoWrapCell>{row.statusName}</NoWrapCell>
        </TableCell>

        <TableCell width={50} align="right">
          <NoWrapCell>{row.orderNumber}</NoWrapCell>
        </TableCell>

        <TableCell width={50} align="right">
          <NoWrapCell>{row.proNumber}</NoWrapCell>
        </TableCell>

        <TableCell width={100} align="right">
          <NoWrapCell>
            {toLocaleIsoString({
              isoDateString: row.puDate,
              format: "MM/DD/YYYY",
            })}
          </NoWrapCell>
        </TableCell>

        <TableCell width={150} align="right">
          <NoWrapCell>{row.puCityName}</NoWrapCell>
        </TableCell>

        <TableCell width={150} align="right">
          <NoWrapCell>{row.delCityName}</NoWrapCell>
        </TableCell>

        <TableCell width={100} align="right">
          <NoWrapCell>
            {toLocaleIsoString({
              isoDateString: row.delDate,
              format: "MM/DD/YYYY",
            })}
          </NoWrapCell>
        </TableCell>

        <TableCell width={100} align="right">
          <NoWrapCell>
            {toLocaleIsoString({
              isoDateString: row.podDate,
              format: "MM/DD/YYYY",
            })}
          </NoWrapCell>
        </TableCell>

        <TableCell width={100} align="right">
          <NoWrapCell>{row.commodityName}</NoWrapCell>
        </TableCell>

        <TableCell width={50} align="right">
          <NoWrapCell>{row.weight}</NoWrapCell>
        </TableCell>

        <TableCell width={50} align="right">
          <NoWrapCell>{row.pallets}</NoWrapCell>
        </TableCell>

        <TableCell width={50} align="right">
          <NoWrapCell>{row.onTime ? "Y" : "N"}</NoWrapCell>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};

export const NoWrapCell = styled("span")`
  width: 100%;
  height: 100%;

  text-wrap: nowrap;
  white-space: nowrap;
  text-transform: uppercase;

  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export default Row;
